/** ****** Reducers ******* */

const initialState = {
  loggedIn: false,
  notifications: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return {
 ...state, ...{ loggedIn: true }, ...action.data, supplierid: action.data?.supplierid?.id || action.data?.supplierid?.id ? { ...action.data.supplierid, id: action.data.supplierid?.id || action.data.supplier_id?.id } : null,
   };
    case 'LOG_OUT':
      localStorage.removeItem('token');
      return initialState;

    default:
      if (localStorage.getItem('token')) {
        return state;
      }
      return initialState;
  }
}
